export default __webpack_public_path__ + "static/media/vinted_logo.216924a9.svg";